import { flatten } from 'lodash-es'

export const handleAxiosError = (error) => {
  // console.dir(error)
  const errorResponse = error?.response
  const errorResponseDataMessage = errorResponse?.data?.message
  const responseErrors = errorResponse?.data?.errors
  const errorMessage = error?.message || error

  if (responseErrors) {
    const responseErrorValues = Object.values(responseErrors)
    const flattenResponseErrorValues = flatten(responseErrorValues)
    return flattenResponseErrorValues && flattenResponseErrorValues[0]
  }

  if (errorResponseDataMessage && errorResponseDataMessage.length > 0) {
    return errorResponseDataMessage
  }

  return errorMessage
}
